import React, { Fragment } from 'react';
export const text = {
  HOPS: 'hops',
  GRAIN: 'grain',
  MISC: 'miscellaneous',
  YEAST: 'yeast'
};

const IngredientTypeText = ({ type, capitalise }) => {
  const ing = text[type] || type;
  return <Fragment>{capitalise ? `${ing.charAt(0).toUpperCase()}${ing.slice(1)}` : ing}</Fragment>;
};

export default IngredientTypeText;



// WEBPACK FOOTER //
// ./src/components/ingredientTypeText/ingredientTypeText.jsx